import { http, HttpResponse } from "msw";
import hsmsData from "../data/hsms";
import { hsmSeedIntervals, currentSseController, sendData } from "./status";
const handlers = [
    http.get("/api/admin/qseed/info", ()=>HttpResponse.json({
            hsms: hsmsData
        })),
    http.post("/api/admin/qseed/update", async ({ request })=>{
        const { hsms: updatedHsms } = await request.json();
        updatedHsms.forEach((updatedHsm)=>{
            const existingHsm = hsmsData.find((hsm)=>hsm.pkcs11Path === updatedHsm.pkcs11_path);
            if (existingHsm && Array.isArray(updatedHsm.tokens)) {
                updatedHsm.tokens.forEach((updatedToken)=>{
                    const existingToken = existingHsm.tokens.find((token)=>token.serialNumber === updatedToken.serial_number);
                    if (existingToken) {
                        existingToken.bytes = updatedToken.bytes;
                        existingToken.seconds = updatedToken.seconds;
                    }
                });
            }
        });
        // Clear current seed intervals.
        hsmSeedIntervals.forEach((intervalInfo)=>{
            clearInterval(intervalInfo.id);
        });
        // Restart intervals using the updated hsmsData
        if (currentSseController) {
            hsmsData.forEach((hsm)=>{
                hsm.tokens.forEach((token)=>{
                    const intervalId = setInterval(()=>{
                        const success = Math.random() < 0.8;
                        let data = {
                            pkcs11_path: hsm.pkcs11Path,
                            serial_number: token.serialNumber,
                            timestamp: Date.now() / 1000,
                            success
                        };
                        if (!success) {
                            data.errorMessage = "Sample token error";
                        }
                        sendData({
                            title: "seed",
                            data,
                            controller: currentSseController
                        });
                    }, token.seconds * 1000);
                    hsmSeedIntervals.push({
                        id: intervalId,
                        pkcs11_path: hsm.pkcs11Path,
                        serial_number: token.serialNumber
                    });
                });
            });
        }
        return HttpResponse.json({
            success: true
        });
    })
];
export default handlers;
